//
import axios from "axios";
import fireDb from "../../api/firebase/realtime/utils";
import apiUrls from "../../api/project/ApiUrls";

/**
 *
 * @param email {string}
 * @returns {Promise<{success: boolean, error: string; providerId: null|undefined|string[]}>}
 */
export const checkEmailExist = async (email) => {
  try {
    if (!email) {
      return {
        success: false,
        error: "email is required for checkEmailExist()",
      };
    }
    const res = await axios.post(apiUrls.postCheckEmailExist(), {
      email,
    });
    if (res.status === 200 && res.data?.message && res.data.message !== false) {
      return {
        success: true,
        error: false,
        providerId: res.data.providerId,
      };
    }
    return {
      success: false,
      error: "user is not exist",
    };
  } catch (e) {
    console.log("err", e);
    return {
      success: false,
      error: e.message,
    };
  }
};
